import React from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./PlayInAppModal.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import { GenericModalProps } from "../../../utils/constants/generic-types";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import { openApp } from "../../../utils/helpers";
import ImageFallbackThumbnail from "../../../images/fallback-thumbnail.png";

interface PlayInAppModalProps extends GenericModalProps {
  gameName?: string;
  thumbnail?: string;
}

function PlayInAppModal({
  isOpen,
  onClose,
  gameName,
  thumbnail,
}: PlayInAppModalProps) {
  const { t } = useTranslation("games");

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      containerClass="play-in-app-drawer"
    >
      <div className="play-in-app-modal">
        <div className="game-image-wrap">
          <Image
            src={thumbnail || ImageFallbackThumbnail}
            alt=""
            width={120}
            height={120}
            className="game-image"
          />
        </div>
        <h2>{gameName}</h2>
        <p>{t("play_in_app_modal.content")}</p>
        <PrimaryActionButton
          size="lg"
          text={t("play_in_app_modal.play_in_the_app")}
          onClick={() => openApp()}
        />
      </div>
    </BottomDrawer>
  );
}

export default PlayInAppModal;
